/* eslint-disable no-dupe-keys */
/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageCustomers from "./manageCustomers";
import ManageCustomerDetail from "./manageCustomers/view";

import ManageCategories from "./manageCategories";
import ManagePayments from "./managePayments";
import ManageSubadmin from "./manageSubadmin";
import ManageAnalytics from "./manageAnalytics";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageReviews from "./manageReviews";
import ManageCms from "./manageCms";
import AddCustomer from "./manageCustomers/add";

import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";

import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import OfferManagement from "./offer-management";
import BuildOffer from "./offer-management/dinning/buildOffer";
import PreviewOffer from "./offer-management/dinning/previewOffer";
import ManageEmployee from "./employee-management";
import AddEmployee from "./employee-management/addEmployee";
import ViewEmployee from "./employee-management/viewEmployee";
import RsvpTracker from "./rsvp-track";
import ManageButterflyEffect from "./manageButterflyEffect";
import RsvpBookingDetail from "./rsvp-track/bookingDetail";
import BookingDetailView from "./rsvp-track/bookingDetailView";
import Cancellation from "./cancellation";
import Booking from "./cancellation/booking";
import Userlist from "./offer-management/userList";
import PreviewOfferDetail from "./offer-management/dinning/previewOfferDetail";
import AddUser from "../features/manageCustomers/addCustomer";
import ManageGroups from "./groups-and-tags";
import ManageTags from "./groups-and-tags/tags";
import ManageSubscription from "./manage-subscription";
import AddSubscription from "./manage-subscription/addSubscription";
import ViewSubscription from "./manage-subscription/viewSubscription";
import CoupanManagement from "../coupon-management";
import ViewGroup from "./manageCms/viewGroup";
import EditHistory from "./rsvp-track/editHistory";
import OthersForm from "./offer-management/dinning/othersForm";
import AddMember from "./manageCms/addmember";
import ManageTransactions from "./transactions/page";
import AddUserLink from "./offer-management/dinning/adduser";
import AddExceptionalGuest from "./rsvp-track/addexceptionalguest";
import Groups from "./groups";
import AddUserBooking from "./rsvp-track/adduserbooking";
import ViewUsers from "./manageNotifications/viewUsers";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageCustomers,
  ManageCustomerDetail,
  AddCustomer,
  ViewGroup,
  EditHistory,
  ManageCategories,
  ManagePayments,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ManageAnalytics,
  OthersForm,
  ManageNotifications,
  RecievedNotifications,
  ManageReviews,
  AddExceptionalGuest,
  ManageCms,
  ManageProfile,
  EditProfile,
  AddUserBooking,
  Groups,
  ChangePassword,
  OfferManagement,
  BuildOffer,
  PreviewOffer,
  ManageEmployee,
  AddUserLink,
  AddMember,
  AddEmployee,
  ViewEmployee,
  RsvpTracker,
  RsvpBookingDetail,
  BookingDetailView,
  ManageButterflyEffect,
  Cancellation,
  Booking,
  Userlist,
  ManageTransactions,
  PreviewOfferDetail,
  AddUser,
  ManageGroups,
  ManageTags,
  ManageSubscription,
  AddSubscription,
  ViewSubscription,
  CoupanManagement,
  ViewUsers,
};
